export default __webpack_public_path__ + "static/scissors-ea05432f38d781ccc3a601b5426f4173.png";